// extracted by mini-css-extract-plugin
export default {"anchor":"ConnectorAnchor_anchor__hHAQE","left":"ConnectorAnchor_left__Zg6vp","right":"ConnectorAnchor_right__nS0BQ"};